









































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Gasthreshold from "../../../store/entities/gasthreshold";
@Component
export default class CreateGasthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  gasthreshold: Gasthreshold = new Gasthreshold();
  idisable:boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.gasthresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "gasthreshold/create",
          data:this.gasthreshold
        });
        (this.$refs.gasthresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.gasthresholdForm as any).resetFields();
            this.$emit('input',false);
        }
  gasthresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    Maxoxygen: [{required: true, message: "请填写氧气最高浓度", trigger: "blur" }],
    Minoxygen: [{required: true, message: "请填写氧气最低浓度", trigger: "blur" }],
    Maxcarbondioxide: [{required: true, message: "请填写二氧化碳最高浓度", trigger: "blur" }],
    Maxnitrogen: [{required: true, message: "请填写氮气最高浓度", trigger: "blur" }],
    Maxchlorinehydride: [{required: true, message: "请填写磷化氢最高浓度", trigger: "blur" }],
    maxcarbonicoxide: [{required: true, message: "请填写一氧化碳最高浓度", trigger: "blur" }],
  };
}
